import { defineComponent as _defineComponent } from 'vue'
import ContactUsLink from "@/components/landing/ContactUsLink.vue";
  import { CALENDLY_BUILD_LINK } from "@/constants/calendlyLinks";

export default /*@__PURE__*/_defineComponent({
  __name: 'HouseQuestion',
  setup(__props, { expose: __expose }) {
  __expose();

  
const __returned__ = { ContactUsLink, get CALENDLY_BUILD_LINK() { return CALENDLY_BUILD_LINK } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})